import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { personalInfoSchema } from '../../services/validationSchemas';
import './Steps.css';

const StepPersonalInfo = ({ formData, onUpdate, onNext, onBack }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: zodResolver(personalInfoSchema),
    defaultValues: {
      first_name: formData.first_name || '',
      last_name: formData.last_name || '',
      national_id: formData.national_id || '',
    },
    mode: 'onChange',
  });

  const onSubmit = (data) => {
    onUpdate(data);
    onNext();
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <span className="step-icon">👤</span>
        <h2 className="step-title">Información Personal</h2>
        <p className="step-subtitle">
          Cuéntanos un poco sobre ti para crear tu perfil de repartidor
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="step-form">
        <div className="form-group">
          <label htmlFor="first_name">Nombres</label>
          <input
            id="first_name"
            type="text"
            placeholder="Ej: Juan Carlos"
            className={errors.first_name ? 'error' : ''}
            {...register('first_name')}
          />
          {errors.first_name && (
            <span className="error-message">{errors.first_name.message}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="last_name">Apellidos</label>
          <input
            id="last_name"
            type="text"
            placeholder="Ej: Pérez García"
            className={errors.last_name ? 'error' : ''}
            {...register('last_name')}
          />
          {errors.last_name && (
            <span className="error-message">{errors.last_name.message}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="national_id">Número de Cédula</label>
          <input
            id="national_id"
            type="text"
            placeholder="Ej: 1712345678"
            className={errors.national_id ? 'error' : ''}
            {...register('national_id')}
            maxLength={13}
          />
          {errors.national_id && (
            <span className="error-message">{errors.national_id.message}</span>
          )}
          <span className="input-hint">Ingresa tu número de cédula sin guiones</span>
        </div>

        <div className="step-actions">
          <button type="button" className="btn-secondary" onClick={onBack}>
            <span className="btn-arrow">←</span>
            Atrás
          </button>
          <button type="submit" className="btn-primary" disabled={!isValid}>
            Continuar
            <span className="btn-arrow">→</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default StepPersonalInfo;
